import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError } from '@shared/helpers/form.helper';
import { toNum } from '@shared/helpers/math.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { CHECK_THE_ENTERED_VALUE, REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isEqual } from 'lodash-es';
import { getBaseSocialeControl } from './helpers/base-sociale-form.helper';

export const baseSocialeStoricoRules: FormGroupRules = {
    my_SociFisCoopPrimo: (form: FormGroup) => {
        mySociHelper(form, 'my_SociFisCoopPrimo', 'my_Data1EsPrec');
    },

    my_SociGiuCoopPrimo: (form: FormGroup) => {
        mySociHelper(form, 'my_SociGiuCoopPrimo', 'my_Data1EsPrec');
    },

    my_SociFisFinPrimo: (form: FormGroup) => {
        mySociHelper(form, 'my_SociFisFinPrimo', 'my_Data1EsPrec');
    },

    my_SociGiuFinPrimo: (form: FormGroup) => {
        mySociHelper(form, 'my_SociGiuFinPrimo', 'my_Data1EsPrec');
    },

    my_SociSpecPrimo: (form: FormGroup) => {
        mySociHelper(form, 'my_SociSpecPrimo', 'my_Data1EsPrec');
    },

    my_SociFisCoopSecondo: (form: FormGroup) => {
        mySociHelper(form, 'my_SociFisCoopSecondo', 'my_Data2EsPrec');
    },

    my_SociGiuCoopSecondo: (form: FormGroup) => {
        mySociHelper(form, 'my_SociGiuCoopSecondo', 'my_Data2EsPrec');
    },

    my_SociFisFinSecondo: (form: FormGroup) => {
        mySociHelper(form, 'my_SociFisFinSecondo', 'my_Data2EsPrec');
    },

    my_SociGiuFinSecondo: (form: FormGroup) => {
        mySociHelper(form, 'my_SociGiuFinSecondo', 'my_Data2EsPrec');
    },

    my_SociSpecSecondo: (form: FormGroup) => {
        mySociHelper(form, 'my_SociSpecSecondo', 'my_Data2EsPrec');
    },
};

const mySociHelper = (form: FormGroup, sociPath: string, dataPath: string) => {
    const my_SociControl = getBaseSocialeControl(form, sociPath);
    const sociValue = toNum(my_SociControl?.value);
    const my_DataPrec = toNum(getBaseSocialeControl(form, dataPath)?.value);
    const errors = my_SociControl.errors ? my_SociControl.errors : {};

    addRemoveError(!isNilOrEmpty(sociValue) && sociValue < 0, errors, sociPath, {
        status: CHECK_THE_ENTERED_VALUE,
    });

    addRemoveError(!isNilOrEmpty(my_DataPrec) && isNilOrEmpty(sociValue), errors, sociPath, {
        status: REQUIRED_STATUS,
    });

    my_SociControl.setErrors(isEqual(errors, {}) ? null : errors);
};
